<template>
  <v-app id="inspire">
    <v-content>
      <v-container class="fill-height" fluid>
        <v-row align="center" justify="center">
          <v-col cols="12" sm="8" md="4">
            <v-card class="elevation-12">
              <v-toolbar color="primary" dark flat>
                <v-toolbar-title>Авторизация</v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>
              <v-card-text>
                <v-alert type="error" v-if="!successLogin">{{ loginErrorMessage }}</v-alert>
                <v-form ref="form" v-model="valid" lazy-validation>
                  <v-text-field
                    label="Логин"
                    name="login"
                    prepend-icon="person"
                    type="text"
                    v-model="login"
                    :disabled="loading"
                    :rules="[rules.required]"
                  ></v-text-field>

                  <v-text-field
                    id="password"
                    label="Пароль"
                    name="password"
                    prepend-icon="lock"
                    type="password"
                    v-model="password"
                    :disabled="loading"
                    :rules="[rules.required]"
                  ></v-text-field>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="submit" :loading="loading">Войти</v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import rules from "../../models/helpers/rules";

export default {
  title: "Авторизация",
  data() {
    return {
      login: "",
      password: "",
      valid: false,
      loading: false,
      rules: rules,
      successLogin: true,
      loginErrorMessage: ''
    };
  },
  methods: {
    async submit() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        const user = {
          Login: this.login,
          Password: this.password
        };

        const success = await this.$store.dispatch("LOGIN", user);
        this.successLogin = success.result;
        this.loading = false;
        if (success.message != '') {
          this.loginErrorMessage = success.message;
        }        

        if (!success.result) return;

        if (this.$store.getters.IS_ADMIN || !this.$store.getters.IS_AUTH_USER) {
          this.$router.push({ name: "DOMAINS_MAP" });
        }

        if (this.$store.getters.IS_AUTH_USER) {
          if (this.$store.getters.IS_CONTRACT) {
            this.$router.push({ name: "USER_PRESETS" });
            return;
          }

          if (this.$store.getters.IS_RADAR_CONTRACT) {
            this.$router.push({ name: "USER_RADAR" });
            return;
          }
        }
      }
    }
  },
  props: {
    source: String
  }
};
</script>